import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Overline } from "./Motion";

export const Facade = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1.25]);

  return (
    <section id="facade" ref={ref} className="relative h-[90vh] min-h-[560px] overflow-hidden bg-royal-deep">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src="/products/terracotta-facade.png" alt="Terracotta facade cladding system — architectural clay facade by Fascinated by Floors" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-r from-royal-deep/80 via-royal-deep/30 to-transparent" />

      <div className="relative h-full max-w-[1400px] mx-auto px-6 md:px-10 flex items-center">
        <div className="max-w-xl text-white">
          <Overline light>Our very best</Overline>
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="mt-5 font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95]"
          >
            Terracotta <span className="italic text-terracotta">Facades.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="mt-6 text-white/80 lg:text-lg leading-relaxed"
          >
            Breathing, sculptural building skins in fired clay — the signature of our practice.
            Ceilings, from acoustic grids to metal waffle, complete the envelope.
          </motion.p>
        </div>
      </div>
    </section>
  );
};
